export default "__VITE_ASSET__Dn1VZ6YQ__"